var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.774,
    height: 28.774,
    viewBox: "0 0 28.774 28.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15755",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15755",
    transform: "translate(-286.999 -544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Key",
    transform: "translate(289 546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21707",
    "data-name": "\\u30D1\\u30B9 21707",
    d: "M0,0H25.059V25.059H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21708",
    "data-name": "\\u30D1\\u30B9 21708",
    d: "M14.164,16.176a6.265,6.265,0,1,0,0,4.176h4.542v4.176h4.176V20.353H24.97V16.176Zm-5.9,4.176a2.088,2.088,0,1,1,2.088-2.088A2.088,2.088,0,0,1,8.265,20.353Z",
    transform: "translate(-0.956 -5.735)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sign_Out",
    "data-name": "Sign Out",
    transform: "translate(287.018 543.809)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10547",
    "data-name": "\\u9577\\u65B9\\u5F62 10547",
    width: 28.774,
    height: 28.774,
    transform: "translate(-0.019 0.191)",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingAccount);
export default __webpack_public_path__ + "static/media/settingAccount.674d3821442896f0ff265f3e2cf61175.svg";
export { ForwardRef as ReactComponent };